module.exports = __webpack_public_path__ + "img/monochrome-photo-of-hallway-2876055.98dbde70.jpg";